import { IButtonStyles, IIconStyles, IStackSlots, IStyle, mergeStyles } from "@fluentui/react";
import { CSSProperties } from "react";

const commandButtonBorderColor = "#0f6cbd";
const commandButtonColor: string = "rgb(26, 27, 25)";
export const STYLES = {
  commandButton: {
    root: {
      backgroundColor: "white",
      border: "1px solid #d1d1d1",
      borderRadius: 16,
      boxShadow: "0 0 2px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.14)",
      cursor: "default",
      color: commandButtonColor,
      maxWidth: "none",
      minHeight: "auto",
      padding: "16px 20px 20px",
      transition: "transform .2s ease-in-out",
      userSelect: "text"
    },
    rootHovered: {
      backgroundColor: "white !important",
      border: `1px solid ${commandButtonBorderColor}`,
      color: `${commandButtonColor} !important`,
      transform: "translateY(-2px)"
    }
  } as IButtonStyles,
  textContainer: mergeStyles({
    flexGrow: 1,
    display: "block",
    textAlign: "left"
  } as IStyle),
  textContainerLabel: mergeStyles({
    color: commandButtonColor,
    cursor: "text",
    display: "block",
    fontWeight: 600,
    lineHeight: "20px",
    marginBottom: 12
  } as IStyle),
  textContainerLabelIcon: {
    color: commandButtonBorderColor,
    fontSize: 20,
    fontWeight: 600
  } as CSSProperties,
  textContainerDescription: mergeStyles({
    color: commandButtonColor,
    cursor: "text",
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: "normal",
    lineHeight: "20px"
  } as IStyle),
  textContainerDescriptionContent: {
    root: {
      borderRadius: ".6em",
      display: "inline-flex",
      fontWeight: 600,
      gridColumnGap: 8,
      padding: ".2em .8em"
    }
  } as IStackSlots,
  textContainerDescriptionContentIcon: {
    root: {
      fontWeight: 600
    }
  } as IIconStyles,
  actionButton: { root: { height: "100%" }, icon: { fontSize: 20 } } as IButtonStyles,
  aiInsightsPanelContent: { root: { marginTop: 24, gridRowGap: "12px" } } as IStackSlots
};